import { render, staticRenderFns } from "./ghInput.vue?vue&type=template&id=528c2d2c&scoped=true&"
import script from "./ghInput.vue?vue&type=script&lang=js&"
export * from "./ghInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c2d2c",
  null
  
)

export default component.exports